import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchActivitiesByUseCase } from '../../actions/tenantStats';
import LineChart from '../charts/LineChart';
import { lineGraph } from '../charts/templates/lineGraph';
import Logger from '../../util/Logger';
import User from '../../models/User';
import { AnalyticsCardHeader } from './AnalyticsCardHeader';
import './ActivitiesByUseCase.css';
import Tenant from '../../models/Tenant';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import { handleError } from '../../util/Errors';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import DateTime from '../../models/DateTime';

class ActivitiesByUseCase extends Component {

  getYAxisTitle = () => {
    return {
      'title': {
        'text': '# of Activities'
      }
    };
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('Missing user in ActivitiesByUseCase component');
    }
  }

  fetchActivites = () => {
    const { user, fetchActivitiesByUseCase, dateRange } = this.props;
    fetchActivitiesByUseCase(Tenant.getId(User.getTenant(user)), dateRange.value);
  };

  componentDidMount () {
    this.fetchActivites();
  }

  componentDidUpdate (prevProps) {
    const { dateRange, activitesError } = this.props;
    if (prevProps.dateRange.value !== dateRange.value) {
      this.fetchActivites();
    }

    handleError(activitesError, prevProps.activitiesError);
  }

  formatActivitiesData () {
    const { activities } = this.props;
    if (!activities) {
      return [];
    }
    let meetingCount = []; // the values to be plotted along y-axis
    let improvementCount = [];
    let surveyCount = [];
    let customCount = [];
    let pointStart; // first date on x-axis
    let pointInterval; // time interval between data points
    activities.forEach((timeInterval, index) => {
      let { startTime, endTime, meeting, improvement, survey, custom } = timeInterval;
      if (index === 0) {
        pointStart = startTime * 1000; // server returns seconds - Highcharts needs millis
        pointInterval = (endTime - startTime) * 1000; // server returns seconds - Highcharts needs millis
      }
      meetingCount.push(meeting);
      improvementCount.push(improvement);
      surveyCount.push(survey);
      customCount.push(custom);
    });
    return [
      {
        name: 'Meetings',
        data: meetingCount,
        pointStart: pointStart,
        pointInterval: pointInterval
      },
      {
        name: 'Improvement',
        data: improvementCount,
        pointStart: pointStart,
        pointInterval: pointInterval
      },
      {
        name: 'Survey',
        data: surveyCount,
        pointStart: pointStart,
        pointInterval: pointInterval
      },
      {
        name: 'Custom',
        data: customCount,
        pointStart: pointStart,
        pointInterval: pointInterval
      }
    ];
  }

  formatTooltip = (tooltip) => {
    const unformatted = [];
    for (let point of tooltip.points) {
      unformatted.push({
        color: point.color,
        name: point.series.name,
        value: point.y
      });
    }

    const values = [];
    for (let unformattedEntry of unformatted) {
      switch (unformattedEntry.name) {
        case 'Meetings':
          values[0] = unformattedEntry;
          break;
        case 'Improvement':
          values[1] = unformattedEntry;
          break;
        case 'Survey':
          values[2] = unformattedEntry;
          break;
        case 'Custom':
          values[3] = unformattedEntry;
          break;
        default:
          // Unexpected, continue anyway
          values.push(unformattedEntry);
      }
    }

    return (`
<div class="col">
    <div class="row no-gutters h-100 text-nowrap p-0 m-0" style="min-width: 12rem; margin-left: -1rem !important; margin-right: -1rem !important;">
      <div class="text-left fix-ie font-weight-bold mb-1">${DateTime.format(
      DateTime.unixSecondsToMoment(tooltip.x / 1000), 'ddd, MMM DD, YYYY')}</div>
    </div>
  ${ values.map(v => {
      return (`
  <div class="row no-gutters h-100 text-nowrap px-0 m-0" style="min-width: 10rem; margin-left: -1rem !important; margin-right: -1rem !important; margin-top 0.1rem; margin-bottom: 0.1rem;">
      <div style="background: ${v.color}; min-width: 0.5rem; max-width: 0.5rem; min-height: 0.5rem; max-height: 0.5rem;" class="rounded-circle m-auto"></div>
      <div class="text-left fix-ie pl-1">${v.name}</div>
      <div>${v.value}</div>
  </div>
`);
    }).join('')}
</div>
`.trim());
  };

  render () {
    const title = 'WEEKLY ACTIVITIES BY USE CASE';
    const { activitiesLoading, activitiesError, dateRange } = this.props;
    const formattedData = this.formatActivitiesData();
    return (
      <div className="card analytics-card-height">
        <AnalyticsCardHeader
          title={ title }
          dateRange={ dateRange } />
        <div className="row line-chart-container">
          <div className="col-12">
            { activitiesError
              ? (
                <ErrorAndRefresh
                  error="Failed to load Activites by Use Case"
                  onRefresh={ this.fetchActivites } />
              )
              : activitiesLoading
                ? <LoadingAndPulse size={ 20 } color="#3D9AE2" whatIsLoading="activities" />
                : formattedData ? (
                  <LineChart
                    data={ formattedData }
                    chartType={ lineGraph }
                    yAxis={ this.getYAxisTitle() }
                    tooltipFormatter={ this.formatTooltip }
                    chartId={ title } />
                ) : <div>No activity data available.</div> }
          </div>
        </div>
      </div>
    );
  }
}

ActivitiesByUseCase.propTypes = {};
ActivitiesByUseCase.defaultProps = {};

const mapStateToProps = state => {
  return {
    user: state.user.user,
    activitiesLoading: state.tenantStats.activitiesLoading,
    activities: state.tenantStats.activities,
    activitiesError: state.tenantStats.activitiesError
  };
};

export default connect(mapStateToProps, { fetchActivitiesByUseCase })(ActivitiesByUseCase);
